import { toast } from "sonner";

export async function shareLink(url, title) {
  if (navigator.share) {
    try { await navigator.share({ title, url }); return; } catch (e) { if (e?.name === "AbortError") return; }
  }
  try { await navigator.clipboard.writeText(url); } catch {
    const t = document.createElement("textarea");
    t.value = url; document.body.appendChild(t); t.select(); document.execCommand("copy"); t.remove();
  }
  toast("Link copied");
}
